var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115.57 111.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #faa71e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.79,
    cy: 55.95,
    rx: 57.79,
    ry: 55.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.95,37.34c-7.53-6.84-20.85-10.34-29.95-4.64-4.86,3.04-7.16,9.67-5.71,15.17.11.43.63,2.08.87,2.35.28.32.77.24.79-.23.03-.55-.34-1.71-.38-2.39-.21-3.46.55-6.97,2.85-9.62t0,0v27.89c0,1.02-.05,2.04-.21,3.05-.39,2.38-1.23,4.66-2.66,6.64-.28.39-1.91,2.34-2.24,2.36-.11.01-.2-.01-.27-.09-8.36-7.59-9.5-20.68-7.56-31.22.95-5.16,2.8-10.74,6.84-14.28.25-.29.09-.63-.2-.81-.2-.13-1.34.27-1.66.37-13.34,4.32-20.18,17.19-17.78,30.85,1.5,8.51,7.14,15.04,14.72,18.92l-3.84.39c-10.7,1.07-19.06-4.63-19.83-15.69v-31.38c.18-.85.63-1.55,1.26-2.07.61-.52,1.4-.87,2.22-1,.57-.09,3.34.09,2.05-.81H11.23c-.32.05-.39.59-.12.68,1.28.04,2.59.05,3.74.68,1.17.63,1.92,1.81,2,3.15v31.12c1.33,17.68,23.76,21.07,37.64,17.67.74-.18,2.65-.94,3.18-.96.37-.02,2.42.71,3,.85,12.38,3.01,27.98.91,37.03-8.68,10-10.62,8.97-28.57-1.75-38.3ZM82.68,78.93c-5.54,3.98-13.37,4.44-19.54,1.68,0,0,0,0,0,0,1.21-1.11,2.47-2.15,3.49-3.45,1.8-2.29,2.92-4.98,3.48-7.8.29-1.45.39-2.93.39-4.41v-31.08c.06-.07.65-.2,1.28-.32.62-.11,1.27-.21,1.45-.23,8.85-.92,14.84,5.26,17.29,13.15,3.28,10.58,1.77,25.58-7.84,32.47Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/FooterLogo.cbcf95c8fe3633e874b5460c95f30d2b.svg";
export { ForwardRef as ReactComponent };